<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Blacklist Nasabah</h5>
            </template>
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group label="Filter" label-for="filterInput" class="form-inline form-group-wrapper mb-3">
                    <div class="d-flex search-input-wrapper">

                        <b-form-input class="mx-2" v-model="filter.filterIdentityNumber" name="filterTable" id="filterInput"
                            placeholder="No. Identitas" @keyup.enter="onFilter" ></b-form-input>

                        <b-form-select
                            class="mr-2"
                            v-model="filter.perihal"
                            :options="perihalOpt"
                            value-field="id"
                            text-field="name"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="null">Semua Perihal</b-form-select-option>
                            </template>
                        </b-form-select>

                        <b-button class="mr-2" variant="pgiBtn" :disabled="isBusy" name="searchTableBtn" @click="onFilter">
                            <i class="fa fa-search"></i>
                        </b-button>
                        <b-button variant="pgiBtn" name="reseFilterBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                    </div>
                </b-form-group>
                <b-button class="mb-3" variant="pgiBtn" name="dataAddBtn" @click="inputBlacklist">Tambah
                    Blacklist</b-button>
            </div>
            <b-table bordered hover show-empty :busy="isBusy" :items="data" :fields="fields" :no-local-sorting="false"
                @sort-changed="sortingChanged" responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data.
                </template>
                <template v-slot:cell(regarding)="row">
                    {{ row.item.perihal.name }}
                </template>
                <template v-slot:cell(createdBy)="row">
                    {{ row.item.createdBy }} , {{ $helper.changeDateFormat(row.item.createdAt) }} {{
                        $helper.changeDateFormatGetHour(row.item.createdAt) }}
                </template>
                <template v-slot:cell(action)="row">
                    <b-button class="btn btn-sm mr-2" v-b-tooltip.hover title="Hapus Data" variant="danger"
                        @click="modalDelete(row.item.id)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="filter.show" id="showItems" :options="options" @change="onLimitChange">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0" v-model="currentPage" :total-rows="rows" :per-page="perPage"
                    aria-controls="my-table" @input="onPageChange"></b-pagination>
            </div>

            <b-modal id="modal-input-blacklist" title="Input Blacklist" no-close-on-backdrop>
                <div>
                    <label>No. Identitas</label>
                    <b-form-input class="mr-2" v-model="input.identityNumber" name="noIdentitas" id="noIdentitas"
                        placeholder="No. Identitas..." maxlength="100"></b-form-input>
                </div>
                <div class="my-2">       
                    <label>Perihal</label>
                    <multiselect v-model="input.regarding" :options="perihalOpt" :internal-search="true"
                    :allow-empty="false" deselect-label="" select-label="" label="name" track-by="id"
                    placeholder="-- Please select an option --" />
                </div>
                <div class="my-2">
                    <label>Alasan</label>
                    <b-form-textarea class="mr-2" v-model="input.reason" name="alasan" id="alasan" placeholder="Alasan..."
                        maxlength="255"></b-form-textarea>
                </div>

                <div class="d-flex">
                    <b-form-checkbox class="mr-2" v-model="input.alsoBlacklistNasabah" />
                    <label>Langsung Blacklist nasabah aktif dengan nomor identitas ini</label>
                </div>

                <template v-slot:modal-footer="{ cancel }">
                    <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                        Tutup
                    </b-button>
                    <b-button variant="pgiBtn" :disabled="loading" name="closeDetailBtn" @click="confirmSubmit()">
                        {{ loading ? 'Loading...' : 'Submit' }}
                    </b-button>
                </template>
            </b-modal>

            <ModalConfirm id="conf-input-blacklist" title="Konfirmasi Tambah" :isSubmitting="loading"
                desc="Apakah anda yakin untuk menambah Data ini ?" @submit="onSubmit" />

            <ModalConfirm id="modal-delete" title="Konfirmasi Hapus Data" :isSubmitting="loading"
                desc="Apakah anda yakin untuk hapus Data ini ?" @submit="onDelete" />

        </b-card>
    </div>
</template>

<script>
export default {
    name: 'master-user-staff',
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            filter: {
                show: 10,
                filterUsername: null,
                perihal: null,
                sortBy: null,
                sortDesc: null,
            },

            input: {
                identityNumber: '',
                reason: '',
                regarding: null,
                alsoBlacklistNasabah: false,
            },

            activeItem: null,
            fields: [
                { key: "identityNumber", label: "No. Identitas" },
                { key: "regarding", label: "Perihal" },
                { key: "reason", label: "Alasan" },
                { key: "createdBy", label: "Dibuat Oleh / Pada" },
                { key: "action", label: "Aksi" },
            ],
            data: [{
                cabang: []
            }],
            options: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],
            optionRole: [],

            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: "",

            perihalOpt: []
        }
    },
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init() {
            this.initStatus = 0
            this.page = 0
            this.size = this.filter.show
            this.query = this.$helper.makeQuery(this.page, this.size)

            let getRole = this.$axios.get("role/").then(response => {
                this.optionRole = response.data

                for (var x of this.optionRole) {
                    x.name = "Level " + x.level + " - " + x.name
                }
            })

            let getBlacklist = this.$axios.get("nasabah-blacklist/" + this.query).then(response => {
                this.data = response.data.data
                this.updateTotalItem(response.data.total)
            })

            let getOptionPerihal = this.$axios.get(`/perihal/?type=2&isActive=true`).then(response => {
                this.perihalOpt = response.data
            })

            Promise.all([getRole, getBlacklist, getOptionPerihal]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
                .catch(error => {
                    console.log(error)
                    this.initStatus = -1
                })
        },


        //----------------- Fungsi Ambil Data User Staff -----------------

        getBlacklist() {
            this.toggleBusy()
            this.data = []

            if (this.filter.filterIdentityNumber != null) this.query = this.query + "&filterIdentityNumber=" + this.filter.filterIdentityNumber

            if (this.filter.sortBy != null) {
                if (this.filter.sortBy == "fullname") this.query = this.query + "&sortBy=fullName"
                else this.query = this.query + "&sortBy=" + this.filter.sortBy
            }
            if (this.filter.sortDesc != null) this.query = this.query + "&sortDesc=" + this.filter.sortDesc

            if (this.filter.perihal) {
                this.query = this.query + "&filterPerihalId=" + this.filter.perihal
            }

            this.$axios.get("nasabah-blacklist/" + this.query).then(response => {
                this.data = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                    this.toggleBusy()
                    this.loading = false
                })
        },


        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange() {
            this.size = this.filter.show
            this.perPage = this.filter.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getBlacklist()
        },

        onPageChange() {
            if (this.loading == false) {
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getBlacklist()
            }
        },

        sortingChanged(ctx) {
            if (ctx.sortBy != "") {
                this.filter.sortBy = ctx.sortBy
                this.filter.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset() {
            this.filter.filterIdentityNumber = null
            this.filter.perihal = null

            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getBlacklist()
        },

        onFilter() {
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getBlacklist()
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total) {
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan " + prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        inputBlacklist() {
            this.resetInput()
            this.$bvModal.show('modal-input-blacklist')
        },

        confirmSubmit() {
            if (this.$helper.isNullOrEmpty(this.input.identityNumber) || this.$helper.isNullOrEmpty(this.input.reason) || this.$helper.isNullOrEmpty(this.input.regarding)) {
                return this.$helper.toastErr(this, 'Mohon Lengkapi Data')
            }
            this.$bvModal.show('conf-input-blacklist')
        },

        onSubmit() {
            this.loading = true
            
            let params = `?identityNumber=${this.input.identityNumber}&regarding=${this.input.regarding.id}&reason=${this.input.reason}&alsoBlacklistNasabah=${this.input.alsoBlacklistNasabah}`

            this.$axios.post("nasabah-blacklist/" + params, { timeout: 300000 }).then(response => {
                this.loading = false
                this.getBlacklist()
                this.$bvModal.hide('modal-input-blacklist')
                this.$bvModal.hide('conf-input-blacklist')
                this.$helper.toastSucc(this, "Data Berhasil Ditambahkan")
                this.resetInput()
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.loading = false
                })
        },

        modalDelete(id) {
            this.activeId = id
            this.$bvModal.show('modal-delete')
        },

        onDelete() {
            this.loading = true
            this.$axios.post(`nasabah-blacklist/delete/${this.activeId}`).then(response => {
                this.loading = false
                this.getBlacklist()
                this.$bvModal.hide('modal-delete')
                this.$helper.toastSucc(this, "Data Berhasil Dihapus")
                this.resetInput()
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.loading = false
                })
        },

        resetInput() {
            this.input = {
                identityNumber: '',
                reason: '',
                regarding: null,
                alsoBlacklistNasabah: false,
            }
        }

    },

    created() {
        this.init()
    }
}
</script>
